import React from 'react';
import _ from 'lodash';

import { routes, url } from 'oo-routes';
import Link from 'sp-components/components/Link';

import SectionHeader from '../SectionHeader';

import './styles';

const INTEGRATIONS = [
  // {
  //   name: 'Shopify',
  //   description: "Out of all of the services I've tried, Scalable Press was the only one that personally reached out to me to make sure I was comfortable with everything.",
  //   imageUrl: 'logos/shopify-formated-logo.png',
  //   url: routes.website2.home.shopify,
  // },
  // {
  //   name: 'WooCommerce',
  //   description: '',
  //   imageUrl: 'logos/woo-formated-logo.png',
  //   url: routes.website2.home.woocommerce,
  // },
  {
    name: 'Developer API',
    description: '',
    imageUrl: 'logos/api-logo.png',
    url: routes.website2.home.api,
  },
];

const SHOP_SP = {
  name: 'Shop Scalable Press',
  description: '',
  imageUrl: 'logos/order-online-logo.png',
  url: url('manager', routes.manager.base),
};

const titleText = 'Tools to Help You Grow';
const titleDescription = 'Order manually or choose from different automated ordering options.';

export default class IntegrationSection extends React.Component {
  render() {
    const accentedIntegration = _.first(INTEGRATIONS);

    const integrationGrid = _.map(INTEGRATIONS, (integration, index) => (
      <div key={index} className="four wide computer four wide tablet eight wide mobile column center-aligned p-b-1-m">
        <div className="ui raised segment">
          <Link to={integration.url}>
            <div className="ui fluid image"><img src={require(`../../assets/${integration.imageUrl}`)} /></div>
            <div className="tile-title">{integration.name}</div>
          </Link>
        </div>
      </div>
    ));

    const shopLink =
      (<div className="four wide computer four wide tablet eight wide mobile column center-aligned p-b-1-m">
        <div className="ui raised segment">
          <Link to={SHOP_SP.url}>
            <div className="ui fluid image"><img src={require(`../../assets/${SHOP_SP.imageUrl}`)} /></div>
            <div className="tile-title">{SHOP_SP.name}</div>
          </Link>
        </div>
      </div>);

    return (
      <div className="Integration">
        <div className="ui container p-b-4">

          <SectionHeader titleText={titleText} titleDescription={titleDescription} />
          <div className="ui grid">
            <div className="stretched row">
              {integrationGrid}
              {shopLink}
            </div>
          </div>

        </div>
        <div className="ui divider" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/IntegrationSection/index.jsx